export enum EReduxState {
  IDLE = 'IDLE',
  LOADING = 'LOADING',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR'
}

export type TReduxBooleanState = { loading: boolean; shouldFetch: boolean }

const getLoadingState = (state: EReduxState): boolean =>
  state === EReduxState.LOADING || state === EReduxState.IDLE

const getShouldFetchState = (state: EReduxState): boolean =>
  state === EReduxState.IDLE

export const getBooleanStates = (state: EReduxState): TReduxBooleanState => ({
  loading: getLoadingState(state),
  shouldFetch: getShouldFetchState(state)
})
